/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Name/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function Name({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/Topbar/Sms/Name"
  
}) {
  let isMedia = useIsMedia()
let threadNameValueData = fromData.useDataValue({ viewPath,
context: 'thread',
path: 'name',
})
let threadInboundNotificationValueData = fromData.useDataFormat({ viewPath,
context: 'thread',
path: 'inbound_notification',
format: fromFormat.phoneNumberUS,
})
let constantData = 'No patient match'
let aggregateData = fromAggregate.fallbackIfSame(threadNameValueData, threadInboundNotificationValueData, constantData)
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="thread.name"
 data="thread.inbound_notification"
 format="/Data/format.js phoneNumberUS"
 data="'No patient match'"
 aggregate="/Data/aggregate.js fallbackIfSame"
 text={aggregateData}
 size={isMedia.mobile ? "small" : "large"}
 weight="semibold"
 whiteSpace="wrap"
 maxWidth={isMedia.mobile ? "30%" : "60%"}
 overflowX="hidden"
 height={isMedia.mobile ? "18px" : "22px"}
/>
{children}
</React.Fragment>)
}